import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1489.28,0 1920,430.613333 1920,960 C1920,1489.38667 1489.28,1920 960,1920 C430.72,1920 0,1489.38667 0,960 C0,720.96 88.64,494.08 244.48,320 L244.48,320 L53.3333333,320 L53.3333333,106.666667 L640,106.666667 L640,693.333333 L426.666667,693.333333 L426.666667,439.253333 C291.733333,577.386667 213.333333,762.986667 213.333333,960 C213.333333,1371.62667 548.266667,1706.66667 960,1706.66667 C1371.73333,1706.66667 1706.66667,1371.62667 1706.66667,960 C1706.66667,548.373333 1371.73333,213.333333 960,213.333333 L960,213.333333 Z M1257.93067,690.261333 L1408.75733,841.194667 L921.930667,1328.02133 L617.930667,1023.91467 L768.757333,873.088 L921.930667,1026.368 L1257.93067,690.261333 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSisSyncedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconSisSyncedSolid, _Component);

  var _super = _createSuper(IconSisSyncedSolid);

  function IconSisSyncedSolid() {
    _classCallCheck(this, IconSisSyncedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSisSyncedSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSisSynced",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSisSyncedSolid.displayName = "IconSisSyncedSolid";
  return IconSisSyncedSolid;
}(Component);

IconSisSyncedSolid.glyphName = 'sis-synced';
IconSisSyncedSolid.variant = 'Solid';
IconSisSyncedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSisSyncedSolid;
export { IconSisSyncedSolid };